/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_appsync_graphqlEndpoint": "https://2ie62pafvjbbjmlzig3kmlrhjq.appsync-api.us-east-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-2",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-ditss5mq4ngy3k4dwfei23ounq",
    "aws_cognito_identity_pool_id": "us-east-2:1ad5ee62-8bca-42db-8299-1d4b9f6e67b6",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_1uv3LB7aK",
    "aws_user_pools_web_client_id": "nn0mvrphl0lt8let7gkfvlb4i",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
